import React from 'react';


const loaderClasses = [
  'header-top',
  'left-padding',
  'mid-gutter',
  'line-0',
  'line-1',
  'line-2',
  'line-3',
  'blocker-0',
  'blocker-1',
  'blocker-2',
  'right-padding',
  'header-bottom'
];

function initLoader() {
  return (
    <div className="loader-background">
      { loaderClasses.map((item, idx) => (
        <div className={ `background-masker ${item}` } key={ `loader-${idx}` }></div>
      )) }
    </div>
  );
}

export function Loader({
  isInitialized
}) {
  return isInitialized ? <noscript /> : initLoader();
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/recommendedVideos/components/loader.js